import * as THREE from 'three'


const replaceMaterial = function(mesh, to){
  let newMat = null;
  const oldMat = mesh.material;
  if(oldMat.type == to)
    return;
  
  if(to == 'MeshPhongMaterial'){
    newMat = new THREE.MeshPhongMaterial;
  }else if(to == 'MeshLambertMaterial'){
    newMat = new THREE.MeshLambertMaterial;
  }else if(to == 'MeshBasicMaterial'){
    newMat = new THREE.MeshBasicMaterial;
  }

  // convert
  if(newMat !== null){
    if(newMat.type == "MeshLambertMaterial" ||
       newMat.type == "MeshBasicMaterial"){
      newMat.map = oldMat.map
      newMat.color = oldMat.color;
      newMat.opacity = oldMat.opacity;
      newMat.transparent = oldMat.transparent;
      newMat.envMap = oldMat.envMap;
    }else if(newMat.type == "MeshPhongMaterial"){
      newMat.map = oldMat.map
      newMat.color = oldMat.color;
      newMat.opacity = oldMat.opacity;
      newMat.transparent = oldMat.transparent;
      newMat.envMap = oldMat.envMap;
      newMat.normalMap = oldMat.normalMap;
      newMat.normalMapType = oldMat.normalMapType;
      if(newMat.normalMap != null)
        newMat.name = "normalmap"
      newMat.specular = new THREE.Color( 0x000000 );
      newMat.shininess = 0;
      newMat.emissiveIntensity = 0; 
      
      // console.log(newMat.specular, newMat.emissive, newMat)
    }else{
      console.error("no implementation")
    }
    
    mesh.material.dispose();

    mesh.material = newMat;
  }else{
    console.error("no implementation")
  }
}

const getParameterByName = (name, url)=> {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


const getCubemapPath = (name)=>{
  let path = '/assets/'
  if(name == 'TAKO_Park_Bridge01_IEM')
    path += 'TAKO_Park_Bridge01_IEM/';
  else if(name == 'NR_Parking_IEM')
    path += 'NR_Parking_IEM/';
  else if(name == 'YK_OOSANBASI_IEM')
    path += 'YK_OOSANBASI_IEM/';
  else if(name == 'StdSky_IEM')
    path += 'StdSky_IEM/'
  
  return path;
}

const replaceConfig = (config)=>{
  const defaultMaterial = getParameterByName('defaultMaterial');
  const dirLightIntensity = getParameterByName('dirLightIntensity');
  const ambientLightIntensity = getParameterByName('ambientLightIntensity');
  const subDirLightIntensity = getParameterByName('subDirLightIntensity');
  const cubemapName = getParameterByName('cubemapName');
  
  if(defaultMaterial !== null)
    config.defaultMaterial = defaultMaterial;
  if(dirLightIntensity !== null)
    config.dirLightIntensity = parseFloat(dirLightIntensity);
  if(ambientLightIntensity !== null)
    config.ambientLightIntensity = parseFloat(ambientLightIntensity);
    if(subDirLightIntensity !== null)
    config.subDirLightIntensity = parseFloat(subDirLightIntensity);
  if(cubemapName !== null){
    config.cubeMap = getCubemapPath(cubemapName);
  }

 
} 


export { replaceMaterial, replaceConfig, getParameterByName };
